<script lang="ts">
    import { Label } from '@/components/ui/label/index.js';
    import FieldDescription from './FieldDescription.svelte';
    import type { FilePondCallbackProps } from 'filepond';
    import FilePond, { registerPlugin } from 'svelte-filepond';
    import 'filepond/dist/filepond.css';
    import InputError from '../InputError.svelte';
    import { uuidv7 } from 'uuidv7';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
    import { toast } from 'svelte-sonner';

    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

    registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize);


    type Props = {
        acceptedFileTypes?: string[] | null;
        label?: string | null;
        description?: string | null;
        allowMultiple?: boolean;
        required?: boolean;
        error?: string | null;
        id?: string | null;
        name?: string | null;
        value?: File[] | File | null;
        server: any;
        maxFileSize?: string | null;
        onProcessFile?: FilePondCallbackProps['onprocessfile'];
        onRemoveFile?: FilePondCallbackProps['onremovefile'];
    };
    let {
        acceptedFileTypes = null,
        label = null,
        description = null,
        allowMultiple = false,
        required = false,
        error = null,
        id = uuidv7(),
        name = null,
        onProcessFile,
        onRemoveFile,
        server = null,
        maxFileSize = '30MB',
        value = $bindable(allowMultiple ? [] : null),
    }: Props = $props();
    let pond;

    export function reset() {
        pond?.removeFiles();
    }

    export function getFiles() {
        return pond?.getFiles() || [];
    }

    function handleWarning(error: { body: string; type: string }) {
        if (error.type === 'warning' && error.body) {
            toast.error(error.body);
        }
    }
</script>

<div class="flex flex-col gap-2 w-full">
    <Label for={id}>{label} {#if required}<span class="text-destructive">*</span>{/if} </Label>
    {#if description}
        <FieldDescription>{description}</FieldDescription>
    {/if}
    <FilePond
        bind:this={pond}
        {id}
        {name}
        {acceptedFileTypes}
        server={server}
        {allowMultiple}
        {maxFileSize}
        labelMaxFileSizeExceeded="File is too large"
        labelMaxFileSize={"Maximum file size is {filesize}"}
        onwarning={handleWarning}
        onprocessfile={onProcessFile}
        onremovefile={() => {
        }}
        onupdatefiles={(files) => {
            const rawFiles = files.map(f => f.file);
            value = allowMultiple ? rawFiles : rawFiles[0] || null;
        }}
        {required}
    />
    {#if error}
        <InputError message={error} />
    {/if}
</div>

<style lang="scss">
    :global(a.filepond--credits) {
        display: none;
    }
</style>
